import {DOMAINALN_SERVER} from '../server'
import {athubAxios} from '../../util'

const DomainalnApi = {

    list(params) {
        let url = `${DOMAINALN_SERVER}/domainaln/select`;

        return new Promise((resolve, reject) => {
            athubAxios.postByForm(url, params).then(responseBody => {
                if(responseBody.status == 200){
                    resolve(responseBody.data);
                }
                reject('查询Domainaln信息失败');
            }).catch(error => {
                reject(error);
            });
        })

    },

}

export default DomainalnApi;